<template>
  <div class="sign">
    <div class="sign_icon">
      <img :src="tipItem.icon" />
    </div>
    <div class="sign_awardtext sign_awardtext1">
      获得<span>{{ tipItem.desc }}</span>
    </div>
    <div class="sign_awardtext sign_awardtext2">
      同时<span>经验+{{ tipItem.exp }}、积分+{{ tipItem.score }}</span>
    </div>
    <div class="sign_userName">当前角色:<span>{{ tipItem.roleName }}</span></div>
    <div class="sign_text">可前往游戏邮件内领取奖励</div>
    <div class="sign_btn" @click="tipClose">关闭</div>
  </div>
</template>
<script>
export default {
  name: "sign",
  props: {
    tipItem: {
      typeof: Object,
      default: () => { },
    },
  },
  methods: {
    tipClose() {
      this.$emit("tipChange");
    },
  },
};
</script>
<style scoped></style>